import { mapState, mapActions } from 'vuex'
import RouterName from '@/constants/route'
import { upload } from '@/mixin/file'
// import { ProgrammeType } from '@/constants/type'
import Actions from '@/constants/action'
import { loading } from '@/mixin'
import { Notify } from 'vant'

export const logic = {
  mixins: [upload, loading],
  data() {
    return {
      /* if eventId exist, register this event*/
      eventId: this.$route.query.eventId,
      programmeType: this.$route.query.type,
      campaignId: this.$route.query.campaignId,
      /* basic */
      name: '',
      age: '',
      email: '',
      profilePhotoUrl: '',

      /* for student */
      eduInstitution: '',
      grade: '',
      major: '',

      /* for worker */
      company: '',
      title: '',
      yearsOfWork: '',
      isRegistered: 0,
      industryId: '',
      industryOther: '',
      RefererName: '',
      RefererId: '',
      isRequiredCv: this.$route.query.isRequiredCv,
      educationOrWork: '',
      radio: ''
    }
  },
  created() {
    this.fetchLookups()
    this.getBaseInfo()
  },
  mounted() {
    this.updateComponentInfo()
  },
  computed: {
    ...mapState(['userInfo', 'loading', 'lookups']),
    cLoading() {
      return this.loading.userInfoLoading
    },
    cShowEducation() {
      // return Number(this.programmeType) === ProgrammeType.Anchor
      return this.educationOrWork === 0
    },
    cShowWorkInfo() {
      // return Number(this.programmeType) === ProgrammeType.YouPlus
      return this.educationOrWork === 1
    }
  },
  methods: {
    handleDialogConfirm(cb) {
      // component implemented
    },
    handleDialogMessage(msg) {
      // component implemented
    },
    ...mapActions({
      updateUserInfo: Actions.UPDATE_USER_INFO,
      updateAvatar: Actions.UPDATE_AVATAR,
      fetchLookups: Actions.GET_LOOKUP,
      getBaseInfo: Actions.GET_BASE_INFO
    }),
    updateComponentInfo() {
      this.name = this.userInfo.name || ''
      this.age = this.userInfo.age || ''
      this.email = this.userInfo.email || ''

      this.eduInstitution = this.userInfo.eduInstitution || ''
      this.grade = this.userInfo.grade || ''
      this.major = this.userInfo.major || ''

      this.company = this.userInfo.company || ''
      this.title = this.userInfo.title || ''
      this.yearsOfWork = this.userInfo.yearsOfWork || ''
      this.industryId = this.userInfo.industryId || ''
      this.industryOther = this.userInfo.industryOther || ''
      this.RefererName = this.userInfo.refererName || ''
      this.RefererId = this.userInfo.refererId || ''
    },
    handleReturn() {
      if (this.checkEdit()) {
        return this.handleDialogConfirm(() => {
          this.goBack()
        })
      }
      this.goBack()
    },
    handleSave() {
      let msg = ``

      if (!this.name) {
        // master input name
        msg += '请输入您的名字'
        // return this.handleDialogMessage('请输入您的名字')
      }
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (!this.email || !pattern.test(this.email)) {
        // return this.handleDialogMessage('请输入正确的邮箱')
        msg += `\n 请输入正确的邮箱`
      }
      if (!this.age) {
        msg += `\n 请选择您的年龄段`
        // return this.handleDialogMessage('请选择您的年龄段')
      }
      if (!this.educationOrWork.toString()) {
        msg += `\n 请选择在校学生或职场人士`
        // return this.handleDialogMessage('请选择您的年龄段')
      }
      if (this.cShowWorkInfo && !this.company) {
        msg += `\n 请输入您的公司`
        // return this.handleDialogMessage('请输入您的公司')
      }
      if (this.cShowWorkInfo && !this.title) {
        msg += `\n 请输入您的职位`
        // return this.handleDialogMessage('请输入您的职位')
      }
      if (this.cShowWorkInfo && !this.yearsOfWork) {
        msg += `\n 请选择您的工作年限`
        // return this.handleDialogMessage('请选择您的工作年限')
      }
      if (this.cShowWorkInfo && !this.industryId) {
        // master input name
        msg += `\n 请选择您的行业`
        // return this.handleDialogMessage('请选择您的行业')
      }
      if (this.cShowEducation && !this.eduInstitution) {
        msg += `\n 请输入您的学校`
        // return this.handleDialogMessage('请输入您的学校')
      }
      if (this.cShowEducation && !this.major) {
        msg += `\n 请输入您的专业`
        // return this.handleDialogMessage('请输入您的专业')
      }
      if (this.cShowEducation && !this.grade) {
        msg += `\n 请输入您的年级`
        // return this.handleDialogMessage('请输入您的年级')
      }
      if (this.cIndustry === '其他' && !this.industryOther) {
        msg += `\n 请注明其他行业`
        // return this.handleDialogMessage('请注明其他行业')
      }
      if (msg.length > 0) {
        msg = msg.replace(/^\n/g, '')
        Notify({ type: 'danger', message: msg })
        return
      }
      // if (this.cShowWorkInfo && this.isRequiredCv &&
      //   (!this.userInfo.resumes || this.userInfo.resumes.length === 0)) {
      //   return this.handleDialogMessage('请上传简历')
      // }
      const basic = {
        eventId: this.eventId,

        /* basic */
        name: this.name,
        age: this.age,
        email: this.email,
        educationOrWork: this.educationOrWork,
        eventCampaignId: this.campaignId || this.userInfo.campaignId
        // profilePhotoUrl: this.profilePhotoUrl
      }
      const education = {
        eduInstitution: this.cShowEducation ? this.eduInstitution : '',
        grade: this.cShowEducation ? this.grade : '',
        major: this.cShowEducation ? this.major : ''
      }
      const work = {
        company: this.educationOrWork ? this.company : '',
        title: this.educationOrWork ? this.title : '',
        yearsOfWork: this.educationOrWork ? this.yearsOfWork : '',
        IndustryId: this.educationOrWork ? this.industryId : '',
        IndustryOther: this.educationOrWork ? this.industryOther : '',
        RefererName: this.educationOrWork ? this.RefererName : '',
        RefererId: this.educationOrWork ? this.RefererId : ''
      }

      const updateInfo = Object.assign(basic, education, work)

      // Object.keys(updateInfo).forEach((k) => {
      //   if (!updateInfo[k]) {
      //     Reflect.deleteProperty(updateInfo, k)
      //   }
      // })

      this.updateUserInfo(updateInfo).then(() => {
        this.isRegistered = 1
        this.goBack()
      })
    },
    handleUpdateAvatar(e, dir, isPublic) {
      this.uploadFile(e, dir, isPublic)
        .then(key => {
          return this.updateAvatar({
            item: key
          })
        })
    },
    checkEdit() {
      if (
        this.name || this.age || this.email ||
        this.profilePhotoUrl || this.eduInstitution ||
        this.grade || this.major || this.company ||
        this.title || this.yearsOfWork || this.industryId
      ) {
        return true
      }
      return false
    },
    goBack() {
      // let register = 0
      // if (this.eventId) {
      //   register = 1
      // }
      this.$router.replace({
        name: this.$route.query.from || RouterName.home,
        query: Object.assign({}, this.$route.query, { register: this.isRegistered })
      })
    }
  }
}
